export default {
  headers: [
    ['satellite-tracking/report.date', 'date'],
    ['satellite-tracking/report.drivers', 'drivers']
  ],

  timeVehicleHeaders: [
    ['satellite-tracking/report.date', 'date'],
    ['satellite-tracking/report.registration', 'registration'],
    ['satellite-tracking/report.garage_number', 'garageNumber'],
    ['satellite-tracking/report.brand_model', 'brandModel'],
    ['satellite-tracking/report.drivers', 'drivers']
  ],

  nonDigitalHeaders: [
    ['satellite-tracking/report.time', 'time'],
    ['satellite-tracking/report.voltage', 'voltage']
  ],

  timeHeaders: [
    ['satellite-tracking/report.total_sensor_activity_time', 'active_time']
  ],

  distanceHeaders: [
    ['satellite-tracking/report.total_active_sensor_distance', 'active_distance'],
    ['satellite-tracking/report.total_distance_for_day', 'total_distance']
  ],

  cleaningLastHeaders: [
    ['satellite-tracking/report.cleaning_area', 'total_cleaning_area']
  ],

  defaultLastHeaders: [
    ['satellite-tracking/report.sensor_active_times', 'active_times']
  ]
}
